export default function Footer() {
  return (
    <footer className="bg-white border-t border-gray-200 text-center text-gray-500 py-6 mt-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="text-sm">
          © {new Date().getFullYear()} ReviewForEveryone. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
